/**
 * Legal document version constants — bumped whenever the content of any
 * static legal HTML page under /public materially changes. UserProfile /
 * OrganizerApplication docs snapshot these strings so we know exactly
 * which version each user agreed to (audit trail).
 *
 * Rules of thumb:
 *   - Bump only for MATERIAL changes (obligations, refund policy, data
 *     handling). Typos + formatting are fine to leave alone.
 *   - When a version bumps, the compliance flow re-prompts the user next
 *     time they need to sign (e.g. waivers become stale on version change).
 *   - Keep the constant name aligned with the file it protects.
 */

export const TOS_VERSION = "1.0";
export const PRIVACY_VERSION = "1.0";
export const WAIVER_VERSION = "1.0";
/** Organizer Agreement version — must equal the constant in
 *  services/organizerApplications.ts so the two flows stay in sync. */
export const ORGANIZER_AGREEMENT_VERSION = "v1.0";
/** Participant waiver stays valid for 12 months from signedAt, or until
 *  the version string changes — whichever comes first. */
export const WAIVER_VALIDITY_MONTHS = 12;

/** Static-HTML legal pages served under /public. */
export const LEGAL_URLS = {
  terms: "/terms.html",
  privacy: "/privacy.html",
  organizer: "/organizer.html",
  waiver: "/waiver.html",
} as const;
